import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Whatsapp from '../views/Whatsapp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Whatsapp,
    props: { isRRHH: false }
  },
  {
    path: '/rrhh',
    name: 'Home',
    component: Whatsapp,
    props: { isRRHH: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
